module.exports = __webpack_public_path__ + "img/mesa_el_u.a3774208.png";